<template>
    <div id="skuInfoSearch">
        <a-modal
            :title="$t('loading.detailSearch')"
            :visible="visible"
                :zIndex="98"
            width="85%"
            @cancel="handleCancel"
            :maskClosable=false>
            
            <template slot="footer">                      
                 <a-button @click="searchLoadingByRelIdOrSscc"  class="mlt" size="small" type="primary" > <a-icon  type="search" />{{ $t('skuSearch.search') }}</a-button>
            </template>


            <a-form :form="form">
                  <a-row>
                    <a-col span="3">
                        <a-form-item class="rightAlign">
                            <b>REL_ID</b>
                        </a-form-item>
                    </a-col>
                    <a-col span="7" offset="1">
                        <a-form-item>
                               <div   class="relative">
                                     <a-input
                                             size="small"
                                             placeholder="REL_ID"
                                             autocomplete="off"
                                             style="width: 100%"  
                                             v-model="relId"
                                              />
                                 </div>
                        </a-form-item>
                    </a-col>
                    <a-col span="3" offset="1">
                        <a-form-item  class="rightAlign">
                            <b>SSCC</b>
                        </a-form-item>
                    </a-col>
                    <a-col span="7" offset="1">
                        <a-form-item>
                              <div   class="relative">
                                    <a-input
                                       size="small"
                                       placeholder="SSCC"
                                       autocomplete="off"
                                       v-model="sscc"
                                       style="width: 100%"
                                    />
                                </div>
                        </a-form-item>
                    </a-col>
                </a-row>


            </a-form>
        </a-modal>



    </div>
</template>



<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    import adjustmentSearch from '../adjustAdvanSearch/adjustmentSearch.vue'
    import popSku from '../skuSearch.vue'
    export default {
        components:{  
            adjustmentSearch,
            popSku
            
        },
        data(){
            return {
                visible: false,
                form: this.$form.createForm(this),
                actionSelect:[],
                relId:"",
                sscc:"",
                
            }
        },
        created(){
            //  this.show()
        },
       
        methods:{
            handleCancel(){
                this.visible = false
            },
            show(){
               this.form.resetFields();
               this.visible = true;
               this.relId = "";
               this.sscc = "";
            },
            searchLoadingByRelIdOrSscc(){
                this.visible = false;

                let paramData = {relId:"",sscc:""};
                if (this.relId != "") {
                    paramData.relId = this.relId;
                }
                if (this.sscc != "") {
                    paramData.sscc = this.sscc;
                }
                let jsonString = JSON.stringify(paramData);
                this.$emit("loadingDetailSearchSave", jsonString);
            },



        }
    }
</script>



<style>
   
   .rightAlign{
         text-align: right;
   }
</style>